// extracted by mini-css-extract-plugin
export default {"lineScale":"LineScale_lineScale__PF84r"};